import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Home Intro Verhaal
 * Slug: home_intro
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.home_intro-layout');

	layouts.forEach((layout) => {
		const shape = layout.querySelector(".shape");
		const shapePaths = shape.querySelectorAll("path");

		gsap.from(shapePaths, {
			opacity: 0,
			scale: 0.95,
			x: -10,
			y: 10,
			stagger: 0.05,
			ease: "back.out(2)",
			duration: 0.5,
			scrollTrigger: {
				trigger: shape,
				start: "top+=10% bottom",
				markers: false
			}
		})

		// Slight scrubbed drift against the static shape; stays still under reduced motion
		const image = layout.querySelector(".image-col img");
		if (!image) return;

		gsap.matchMedia().add(
			{
				desktop: "(min-width: 993px) and (prefers-reduced-motion: no-preference)",
			},
			(context) => {
				const { desktop } = context.conditions;
				const drift = desktop ? 40 : 20;

				gsap.fromTo(
					image,
					{ y: drift },
					{
						y: -drift,
						ease: "none",
						scrollTrigger: {
							trigger: layout.querySelector(".image-col"),
							start: "top bottom",
							end: "bottom top",
							scrub: 0.6,
						},
					},
				);
			},
		);
	});
});
